import {
  JSON_FILE,
  JSON_FILE_FAILURE,
  JSON_FILE_SUCCESS,
} from "../../Actions/types";

const initialState = {
  getLoader: false,
  getData: null,
  getError: false,
};
function jsonFileReducer(state = initialState, action) {
  switch (action.type) {
    case JSON_FILE:
      return { ...state, getLoader: true };
    case JSON_FILE_SUCCESS:
      return { ...state, getData: action?.payload, getLoader: false };
    case JSON_FILE_FAILURE:
      return { ...state, getError: true, getLoader: false };

    default:
      return state;
  }
}

export default jsonFileReducer;
